import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { AgGridReact } from 'ag-grid-react';
import cx from 'classnames2';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Button } from '../Button';
import { FilterSortRenderer } from '../Filters';
import { Icon } from '../Icon';
import { AgGridTable, processColumnDefs, processGridOptions } from './AgGridTable';
import styles from './AgGridTreeTable.scss';
import { applyMoveToCell, handleTableKeydown } from './utils/a11yUtils';
var treeOptions = {
  getRowClass: function getRowClass(params) {
    return params.node.uiLevel === 0 ? styles.summarySingleRow : null;
  },
  icons: {
    groupContracted: ReactDOMServer.renderToStaticMarkup(React.createElement(Button, {
      tabIndex: -1,
      size: "small",
      variant: "naked"
    }, React.createElement(Icon, {
      icon: "arrow-chevron-right"
    }))),
    groupExpanded: ReactDOMServer.renderToStaticMarkup(React.createElement(Button, {
      tabIndex: -1,
      size: "small",
      variant: "naked"
    }, React.createElement(Icon, {
      icon: "arrow-chevron-down"
    })))
  }
};
export var AgGridTreeTable = /*#__PURE__*/function (_AgGridTable) {
  _inherits(AgGridTreeTable, _AgGridTable);

  var _super = _createSuper(AgGridTreeTable);

  function AgGridTreeTable() {
    var _this;

    _classCallCheck(this, AgGridTreeTable);

    _this = _super.apply(this, arguments);

    _this.onGridReady = function (params) {
      _this.api = params.api;
      _this.columnApi = params.columnApi;

      if (_this.props.onGridReady) {
        _this.props.onGridReady(params);
      }
    };

    _this.handleKeyDown = function (gridEvent) {
      var event = gridEvent.event;

      if (event.key === 'Tab') {
        var gridBody = document.querySelector('.ag-body-viewport');

        if (gridBody) {
          gridBody.setAttribute('tabIndex', '0');

          _this.api.clearFocusedCell();
        }
      }
    };

    _this.handleGridBodyClick = function (event) {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody && !gridBody.contains(event.target)) {
        gridBody.setAttribute('tabIndex', '0');

        if (_this.api) {
          _this.api.clearFocusedCell();
        }
      }
    };

    _this.handleEnterGrid = function () {
      // scrolls to the first column
      var firstCol = _this.columnApi.getAllDisplayedColumns()[0]; // sets focus into the first grid cell


      _this.api.setFocusedCell(0, firstCol);

      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.setAttribute('tabIndex', '-1');
      }
    };

    _this.makeMoveToCellHandlers = function (index) {
      return function (event) {
        if (event.key === 'ArrowDown') {
          var gridBody = document.querySelector('.ag-body-viewport');

          if (gridBody) {
            gridBody.setAttribute('tabIndex', '-1');
          }

          return handleTableKeydown({
            event: event,
            columnIndex: index,
            gridApi: _this.api,
            columnApi: _this.columnApi,
            isTreeTable: true
          });
        }
      };
    };

    return _this;
  }

  _createClass(AgGridTreeTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.setAttribute('tabIndex', '0');
        gridBody.addEventListener('focus', this.handleEnterGrid);
        window.addEventListener('click', this.handleGridBodyClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.removeEventListener('focus', this.handleEnterGrid);
      }

      window.removeEventListener('click', this.handleGridBodyClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          gridOptions = _this$props.gridOptions,
          width = _this$props.width,
          height = _this$props.height,
          variant = _this$props.variant,
          columnDefs = _this$props.columnDefs,
          rowData = _this$props.rowData,
          filterProps = _this$props.filterProps,
          _this$props$reactKeyV = _this$props.reactKeyValue,
          reactKeyValue = _this$props$reactKeyV === void 0 ? gridOptions.autoGroupColumnDef.headerName : _this$props$reactKeyV,
          _this$props$showLoadi = _this$props.showLoadingOverlay,
          showLoadingOverlay = _this$props$showLoadi === void 0 ? false : _this$props$showLoadi;

      var options = _objectSpread(_objectSpread({}, treeOptions), gridOptions);

      var activeColumnElement = this.state.activeColumnElement;

      options.autoGroupColumnDef.cellClass = function (params) {
        return params.node.uiLevel === 0 ? styles.summarySingleRowCell : null;
      };

      options.autoGroupColumnDef = applyMoveToCell(options.autoGroupColumnDef, this.makeMoveToCellHandlers(0)); // Disable tabbing to navigate cells

      options.tabToNextCell = function (event) {};

      var colDefsWithKeydownHandlers = columnDefs.map(function (colDef, index) {
        return applyMoveToCell(colDef, _this2.makeMoveToCellHandlers(index + 1));
      });
      var colDefs = processColumnDefs(colDefsWithKeydownHandlers, {
        isCondensed: variant === 'condensed',
        handleFilterOpen: filterProps ? this.handleFilterOpen : null
      }).map(function (col) {
        var _cellClassRules;

        return Object.assign({}, col, {
          cellClassRules: (_cellClassRules = {}, _defineProperty(_cellClassRules, styles.summarySingleRowCell, function (params) {
            return params.node.uiLevel === 0;
          }), _defineProperty(_cellClassRules, styles.summaryValueRowCell, function (params) {
            return params.node.uiLevel !== 0;
          }), _cellClassRules)
        });
      });
      var theOptions = processGridOptions(options, {
        isCondensed: variant === 'condensed',
        handleFilterOpen: filterProps ? this.handleFilterOpen : null
      });
      return React.createElement("div", {
        "aria-busy": showLoadingOverlay,
        className: cx(styles.openGov, 'ag-theme-balham'),
        "data-test": 'ag-grid-tree-table',
        style: {
          height: height,
          width: width
        }
      }, React.createElement(AgGridReact, {
        key: reactKeyValue,
        onCellKeyDown: this.handleKeyDown,
        rowData: rowData,
        columnDefs: colDefs,
        gridOptions: theOptions,
        onGridReady: this.onGridReady,
        onBodyScroll: this.handleFilterClose
      }), activeColumnElement && React.createElement(FilterSortRenderer, Object.assign({
        activeColumnDiv: activeColumnElement,
        onClose: this.handleFilterClose
      }, filterProps)));
    }
  }]);

  return AgGridTreeTable;
}(AgGridTable);